import { render, staticRenderFns } from "./pendencias.vue?vue&type=template&id=95dbb6ae&scoped=true"
import script from "./pendencias.vue?vue&type=script&lang=js"
export * from "./pendencias.vue?vue&type=script&lang=js"
import style0 from "./pendencias.vue?vue&type=style&index=0&id=95dbb6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dbb6ae",
  null
  
)

export default component.exports